import { Lightning } from "@lightningjs/sdk";

import { gridHeight, gridWidth } from "../../services/grid.service";

export default class Grid extends Lightning.Component {
  static _template() {
    return {
      Grid: {
        x: 0,
        y: 0,
        children: [
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 1 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 2 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 3 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 4 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 5 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 6 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 7 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 8 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 9 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 10 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 11 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 12 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 13 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 14 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 15 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 16 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 17 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 18 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 19 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 20 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 21 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 22 * gridHeight - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            w: 24 * gridWidth,
            h: 2,
            y: 23 * gridHeight - 1,
            color: 0xff39ff14,
          },

          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 1 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 2 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 3 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 4 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 5 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 6 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 7 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 8 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 9 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 10 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 11 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 12 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 13 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 14 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 15 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 16 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 17 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 18 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 19 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 20 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 21 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 22 * gridWidth - 1,
            color: 0xff39ff14,
          },
          {
            rect: true,
            h: 24 * gridHeight,
            w: 2,
            x: 23 * gridWidth - 1,
            color: 0xff39ff14,
          },
        ],
      },
    };
  }
}
